module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_6005.79ea8f4d.png";